// extracted by mini-css-extract-plugin
export default {"root":"lang-switch_root__SQBCu","button":"lang-switch_button__aPbZi","active":"lang-switch_active__o6ncu"};